module.exports = __webpack_public_path__ + "img/B7.b8f8da7b.svg";